import React from 'react';
import { useSelected } from 'slate-react';
import classnames from 'classnames';
import {
  type ComponentProps,
  type CodeElement,
} from '../../../types/aha-editor';
import Block from '../../Blocks/components/Block';
import selectionStyles from '../../../components/SelectionRectangle/SelectionRectangle.module.css';
import './code-block-styles.css';

const CodeBlock: React.FC<ComponentProps<CodeElement>> = ({
  attributes,
  element,
  children,
}) => {
  const selected = useSelected();

  return (
    <Block
      tag="pre"
      element={element}
      {...attributes}
      className={classnames({
        [selectionStyles.selectionRectangleSelected]: selected,
      })}
    >
      <code className={`prism-language-${element.code_language}`}>
        {children}
      </code>
    </Block>
  );
};

export default CodeBlock;
